import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'lib-gematik-task-api',
    template: `
    <p>
      gematik-task-api works!
    </p>
  `,
    styles: [],
    standalone: false
})
export class GematikTaskApiComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
